import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from "@angular/core";
import { JsonHttpService } from "../http/json-http.service";
import { DxFileUploaderModule } from 'devextreme-angular';

@Component({
    selector: 'ep-file-uploader',
    templateUrl: './file-uploader.component.html',
    styleUrls: ['./file-uploader.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [DxFileUploaderModule]
})
export class FileUploaderComponent {

    @Input() allowedFileExtensions: string[] = [];

    @Output() fileOnValueChangedEvent = new EventEmitter<any>();
    @Output() fileOnBeforeSendEvent = new EventEmitter<any>();
    @Output() fileOnUploadedEvent = new EventEmitter<any>();

    allowedFileExtensionsCollection: string[] = [];

    constructor(private jsonHttpService: JsonHttpService) { }

    getUploadUrl() {
        return this.jsonHttpService.generateBackendUrl('/api/upload/upload-file');
    }

    fileOnValueChanged(args: any): void {
        this.fileOnValueChangedEvent.emit(args);
    }

    fileOnBeforeSend(args: any): void {
        this.fileOnBeforeSendEvent.emit(args);
    }

    fileOnUploaded(args: any) {
        this.fileOnUploadedEvent.emit(args);
    }
}